var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 24,
    viewBox: "0 0 27 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.49988 19.7785C2.71819 20.4524 11.5363 25.5353 17.8072 21.6176C24.0776 17.7 23.7315 10.9503 23.7315 7.8568C24.2999 6.66691 25.4999 6.06185 25.4999 2.8408C24.3214 3.92964 23.1498 4.29975 21.9851 3.95238C20.8445 2.21301 19.275 1.44312 17.2761 1.64396C14.2786 1.94522 13.1822 4.88585 13.5049 8.69112C8.88304 11.028 5.25904 6.99659 3.39083 3.95238C2.76683 6.34985 2.16556 9.22859 3.39083 12.4124C4.20809 14.5357 6.17293 16.3301 9.28409 17.7972C6.13062 19.5056 3.53609 20.1669 1.49988 19.7785Z",
    stroke: "#8A91A8",
    strokeWidth: 1.68421,
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/TWITTER.3dbe4963fa882021d3e863f6e02432d9.svg";
export { ForwardRef as ReactComponent };